import { render, staticRenderFns } from "./club-manager.vue?vue&type=template&id=f2c7f778&scoped=true"
import script from "./club-manager.vue?vue&type=script&lang=js"
export * from "./club-manager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c7f778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2c7f778')) {
      api.createRecord('f2c7f778', component.options)
    } else {
      api.reload('f2c7f778', component.options)
    }
    module.hot.accept("./club-manager.vue?vue&type=template&id=f2c7f778&scoped=true", function () {
      api.rerender('f2c7f778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/club-admins/club-manager.vue"
export default component.exports